<template>
  <router-view />
</template>

<style lang="scss">
@use '@/scss/main.scss';
</style>
